import React from "react";
import { InfoPage } from "./InfoPage";

const Investors = () => (
  <InfoPage
    page="investor"
    eyebrow="FOR INVESTORS"
    title="Backing the future of personal health intelligence."
    paragraphs={[
      "Prosper.AI unifies wearable and health data into one AI-powered platform that turns information into daily action — closing the gap between data collection and behavior change.",
      "We're raising to expand integrations, deepen our AI insight engine, and onboard our early-access community. If you back consumer health, data infrastructure, or AI applications — let's talk.",
    ]}
    ctaTitle="Request the investor deck"
    ctaBody="Share a few details and we'll send our deck, traction, and roadmap."
    bullets={[
      { title: "Massive market", body: "200M+ active wearable users today, growing 25% YoY — most data sits unused." },
      { title: "Defensible moat", body: "Cross-source insight engine, longitudinal personal health memory, integrations breadth." },
      { title: "Strong early signal", body: "Thousands of early-access signups and 100+ wearables / apps integrated." },
      { title: "Built to scale", body: "Modular AI stack, secure data layer, B2C and B2B2C distribution channels." },
    ]}
  />
);

export default Investors;
